import React from "react";
import { useNavigate } from "react-router-dom";
import {
  BlogPageContainer,
  BlogGrid,
  BlogCard,
  BlogImage,
  BlogContent,
  BlogDate,
  BlogTitle,
  BlogDescription,
  ReadMoreButton,
} from "../Styles/StyledblogPage.js";
import b1 from '../Images/b1.webp'
import b2 from '../Images/b2.jpeg'
import b3 from '../Images/b3.webp'
import b4 from '../Images/b4.jpeg'
import b5 from '../Images/b5.jpeg'
import b6 from '../Images/b6.webp'
import b7 from '../Images/b7.jpeg'

const blogs = [
  {
    id: 1,
    date: "7/7/24",
    title: "Three Aspen Snowmass Real Estate Graphs Worth Understanding",
    description: "There always seems to be interest in the Aspen area real estate market...",
    image: b1, // Ensure this path is correct
  },
  {
    id: 2,
    date: "2/18/24",
    title: "Who, What, Why, Where, When...How?",
    description: "There's always opportunity to reflect on the past and set goals for the future...",
    image: b2,
  },
  {
    id: 3,
    date: "2/15/24",
    title: "Getting Paid Now and in the Future (Part 5 of 5): Referrals",
    description: "Did you know that you can set your own percentage for giving/receiving referrals?",
    image: b3,
  },
  {
    id: 4,
    date: "6/12/24",
    title: "Top 10 Tips for Buying Your Dream Mountain Home",
    description: "Here are some essential tips for buying a property in the mountains...",
    image: b4,
  },
  {
    id: 5,
    date: "5/1/24",
    title: "Exploring the Aspen Lifestyle: More Than Just Skiing",
    description: "Discover what makes Aspen a year-round destination beyond skiing...",
    image: b5,
  },
  {
    id: 6,
    date: "3/21/24",
    title: "The Future of Aspen Real Estate in 2025",
    description: "What trends can we expect in Aspen's real estate market in 2025?",
    image: b6,
  },
  {
    id: 7,
    date: "4/10/24",
    title: "How to Successfully Sell Your Aspen Property",
    description: "Learn how to prepare, market, and sell your property in Aspen effectively...",
    image:b7,
  },
];
const BlogPage = () => {
  const navigate = useNavigate();

  return (
    <BlogPageContainer>
      <BlogGrid>
        {blogs.map((blog) => (
          <BlogCard key={blog.id} className="group">
            <BlogImage src={blog.image} alt={blog.title} />
            <BlogContent>
              <BlogDate>{blog.date}</BlogDate>
              <BlogTitle>{blog.title}</BlogTitle>
              <BlogDescription>{blog.description}</BlogDescription>
              <ReadMoreButton onClick={() => navigate(`/blog/${blog.id}`)}>
                Read More
              </ReadMoreButton>
            </BlogContent>
          </BlogCard>
        ))}
      </BlogGrid>
    </BlogPageContainer>
  );
};

export default BlogPage;
